module.exports = __webpack_public_path__ + "img/btn_auto_stop.d958b857.jpg";